exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".actions_holder[data-v-43daf07b] {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.actions_holder button.map-btn[data-v-43daf07b] {\n    width: 32px;\n    height: 32px;\n    border-radius: 16px;\n    margin-right: 12px;\n    text-align: center;\n}\n.actions_holder .supplier_actions_btns[data-v-43daf07b] {\n    width: calc(100% - 40px);\n}\n", ""]);

// exports
